import React from "react";
import { LuUsers, LuChevronRight } from "react-icons/lu";

const CommonTableTeam = ({ columns, data, onClick, renderActions, renderReports, renderCampaign }) => {
  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-100 border-b">
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                className="px-4 py-3 text-left text-sm font-semibold textblack"
              >
                {col.label}
              </th>
            ))}

            {renderActions && (
              <th className="px-4 py-3 text-sm font-semibold textblack text-left">
                Action
              </th>
            )}

            {renderCampaign && (
              <th className="px-4 py-3 text-sm font-semibold textblack text-left">
                Send
              </th>
            )}

            {renderReports && (
              <th className="px-4 py-3 text-sm font-semibold textblack text-left">
                Reports
              </th>
            )}

          </tr>
        </thead>

        {/* ================= BODY ================= */}
        <tbody>
          {data.map((row, index) => (
            <tr
              key={index}
              className="border-b last:border-none hover:bg-gray-50"
            >
              {columns.map((col) => (
                <td key={col.key} className="px-4 py-2 text-sm text-[#111827]">
                  {/* ===== Team Members pill style ===== */}
                  {col.key === "teammembers" ? (
                    <>
                      <div
                        onClick={() => onClick(row)}
                        className="inline-flex items-center gap-2"
                      >
                        <span
                          className="flex items-center cursor-pointer rounded bg-gray-100 text-black 
                          px-2 py-1 
                          hover:bg-gradient-to-r from-[#673AB7] to-[#1976D2] hover:text-white"
                        >
                          <LuUsers size={18} />

                          <span className="px-2 whitespace-nowrap">
                            {row[col.key]}
                          </span>

                          <LuChevronRight size={14} className="ml-1 opacity-70" />
                        </span>
                      </div>




                      {/* <div onClick={() => onClick(row)} className="flex gap-2">
                        <div onClick={() => this.onEditUser(row)}
                          className="flex p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-blue-100 hover:text-blue-600">
                          <LuUsers size={18} />
                          <span> {row[col.key]}</span>
                        </div>
                      </div> */}


                      {/* <div onClick={() => onClick(row)} className="flex items-center gap-2 cursor-pointer">
                        <div className="p-2 rounded bg-gray-100 h-6">
                          <LuUsers size={22} />
                        </div>
                        <span className="text-sm font-medium underline cursor-pointer">
                          {row[col.key]}
                        </span>
                      </div> */}
                    </>
                  ) : col.key === "status" ? (

                    /* ===== Status badge ===== */
                    <span
                      className={`px-4 w-28 mx-auto text-center py-2 rounded-md text-sm font-medium inline-block
                        ${row[col.key] === "Completed"
                          ? "bg-[#E3F2FD] textcolor"
                          : (row[col.key] === "Pending" ? "bg-[#FFFFFF] border border-[#1976D2] textcolor" : "border border-red-200 bg-[#F1F5F9] textblack")
                        }`}
                    >
                      {row[col.key]}
                    </span>
                  ) : (
                    row[col.key]
                  )}
                </td>
              ))}


              {renderActions && (
                <td className="px-4 py-2">
                  {renderActions(row)}
                </td>
              )}


              {renderCampaign && (
                <td className="px-4 py-2">
                  {renderCampaign(row)}
                </td>
              )}



              {renderReports && (
                <td className="px-4 py-2">
                  {renderReports(row)}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CommonTableTeam;
